// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "select[data-v-50600212]{border-width:1px;border-color:currentColor}.has-error[data-v-50600212]{--tw-border-opacity:1;border-color:rgba(217,0,26,var(--tw-border-opacity))}.icon[data-v-50600212]{position:absolute;right:12px;top:50%;margin-top:-8px}", ""]);
// Exports
module.exports = exports;
